'use client';

import { useEffect } from 'react';
import initializeDatadog from 'src/lib/datadog';

const DatadogProvider = () => {
  useEffect(() => {
    initializeDatadog();
  }, []);

  return null;
}

export default DatadogProvider;
